/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowCollapseTrianglesVClosedIcon16Light } from './ArrowCollapseTrianglesVClosedIcon16Light';
import { ArrowCollapseTrianglesVClosedIcon16Regular } from './ArrowCollapseTrianglesVClosedIcon16Regular';
import { ArrowCollapseTrianglesVClosedIcon16Solid } from './ArrowCollapseTrianglesVClosedIcon16Solid';
import { ArrowCollapseTrianglesVClosedIcon20Light } from './ArrowCollapseTrianglesVClosedIcon20Light';
import { ArrowCollapseTrianglesVClosedIcon20Regular } from './ArrowCollapseTrianglesVClosedIcon20Regular';
import { ArrowCollapseTrianglesVClosedIcon20Solid } from './ArrowCollapseTrianglesVClosedIcon20Solid';
import { ArrowCollapseTrianglesVClosedIcon24Regular } from './ArrowCollapseTrianglesVClosedIcon24Regular';
import { ArrowCollapseTrianglesVClosedIcon24Solid } from './ArrowCollapseTrianglesVClosedIcon24Solid';
import { ArrowCollapseTrianglesVClosedIcon32Regular } from './ArrowCollapseTrianglesVClosedIcon32Regular';
import { ArrowCollapseTrianglesVClosedIcon64Regular } from './ArrowCollapseTrianglesVClosedIcon64Regular';
var sizes = {
    16: {
        light: ArrowCollapseTrianglesVClosedIcon16Light,
        regular: ArrowCollapseTrianglesVClosedIcon16Regular,
        solid: ArrowCollapseTrianglesVClosedIcon16Solid,
    },
    20: {
        light: ArrowCollapseTrianglesVClosedIcon20Light,
        regular: ArrowCollapseTrianglesVClosedIcon20Regular,
        solid: ArrowCollapseTrianglesVClosedIcon20Solid,
    },
    24: {
        regular: ArrowCollapseTrianglesVClosedIcon24Regular,
        solid: ArrowCollapseTrianglesVClosedIcon24Solid,
    },
    32: {
        regular: ArrowCollapseTrianglesVClosedIcon32Regular,
    },
    64: {
        regular: ArrowCollapseTrianglesVClosedIcon64Regular,
    },
};
export var ArrowCollapseTrianglesVClosedIcon = forwardRef('ArrowCollapseTrianglesVClosedIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
